import myPic from 'assets/my_Pic.png'
import Typewriter from 'typewriter-effect'
import { Link } from 'react-router-dom'
import { useStateContext } from 'context/StateContext'
import { Helmet } from 'react-helmet-async'

export default function Hero() {
  const { handleButtonSound, handleButtonSound1 } = useStateContext()
  return (
    <>
      <Helmet>
        {/* <Helmet/> component is used to change title, description and tags for each pages. Normally ReactJS use just one "html" file so we can't change title 
        for each page. Helmet is an external library used to add this feature */}
        <meta charSet="utf-8" />
        <title>ستيفن اريك</title>
      </Helmet>
      <div className='px-2' id='hero-section-right-to-left' data-aos="fade-up">
        <div className="row ">
          <div className="col-12 col-lg-6 col-xl-7 d-flex align-items-center px-0 ">
            <div className="hero-inner px-4 px-sm-5 px-lg-4 px-xl-5 py-5">
              <h1>مرحبًا، أنا ستيفن إريك</h1>
              <Typewriter
                options={{
                  strings: ['مطور ويب', 'المصمم المبدع', 'مطور تطبيقات الجوال'],
                  autoStart: true,
                  loop: true,
                  delay: 30,
                  deleteSpeed: 50,
                  wrapperClassName: "type-writer",
                  cursorClassName: "type-writer-cursor"
                }}
              />
              <p className='mt-4 mb-5'>
                أنا مطور ويب محترف ومصمم ويب مقيم في الولايات المتحدة وأعمل في مشاريع مختلفة. يمكنني تصميم تصميمات رائعة بلغات برمجة مختلفة.
              </p>
              {/* <a> tag is used for CV download to add CV in portfolio please add your CV in asset folder in .pdf or any format 
              and after import the file add in "href" and add and attribute "download" in a tag  */}
              <a className='btn btn-warning button-stylling ms-3 py-2 px-3' onClick={handleButtonSound} href="#">تحميل السيرة الذاتية</a>
              <Link className='btn btn-outline-info shadow py-2 px-3 second-button-stylling' to="/right_to_left/about" onClick={handleButtonSound1}>ْعَنِّي</Link>
            </div>
          </div>
          <div className="col-12 col-lg-6 col-xl-5 ">
            <div className="absolute-layer"></div>
            <img src={myPic} alt="my picture" />
          </div>
        </div>
      </div >
    </>
  )
}
